import React, { Component } from 'react'
import FormUtil from '../../utils/FormUtil'
import { Modal, Form, Input } from 'antd'
import Label from '../form/Label'
import UserService from '../../services/UserService'
import ReactGA from 'react-ga'
import { extractAPIError, notifyError } from '../../utils/Util'
const FormItem = Form.Item

class ForgotPasswordModal extends Component {
  state = {
    showSpinner: false,
    visible: false
  }

  showForgotPasswordModal() {
    this.setState({ visible: true })
  }

  onCancel(e) {
    this.setState({ showSpinner: false, visible: false })
  }

  async onClickPasswordReset() {
    const { form } = this.props
    const { errors, values } = await FormUtil.validateForm(form)
    if (!errors) {
      this.resetPassword(values.email)
    }
  }

  async resetPassword(email) {
    this.setState({ showSpinner: true })
    try {
      await UserService.requestPasswordReset(email)
      this.setState({ showSpinner: false, visible: false })
      ReactGA.event({
        category: 'Account',
        action: 'Reset Request',
        label: 'Account Reset Requested'
      })
      this.showPasswordResetConfirm()
    } catch (err) {
      const errMsg = extractAPIError(err)
      console.log('forgot password failed ' + errMsg)
      this.setState({ showSpinner: false })
      ReactGA.event({
        category: 'Account',
        action: 'Reset Request',
        label: 'Account Reset Request Error'
      })
      notifyError(err)
    }
  }

  render() {
    const { visible, showSpinner } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div
        onKeyPress={event => {
          if (event.key === 'Enter') return this.onClickPasswordReset(event)
        }}>
        <Modal
          visible={visible}
          confirmLoading={showSpinner}
          okText="Reset Password"
          onOk={e => this.onClickPasswordReset(e)}
          onCancel={e => this.onCancel(e)}
          destroyOnClose={true}>
          <Form layout="vertical" hideRequiredMark={true}>
            <FormItem label={Label('Email address')} hasFeedback>
              {getFieldDecorator('email', {
                rules: [{ required: true, message: 'Please input your email!' }]
              })(<Input placeholder="your email" />)}
            </FormItem>
          </Form>
        </Modal>
      </div>
    )
  }

  showPasswordResetConfirm() {
    Modal.info({
      title: 'Reset Password',
      content: (
        <div>
          <p>Check your email address for a link to reset your password</p>
          <p>
            If you entered an incorrect email address, please repeat the steps to reset your
            password
          </p>
        </div>
      ),
      onOk() {}
    })
  }
}

const WrappedForgotPasswordModal = Form.create()(ForgotPasswordModal)
export default WrappedForgotPasswordModal



// WEBPACK FOOTER //
// ./src/components/login/ForgotPasswordModal.js